<div class="page-header">
  <div class="left-area">
    <span class="nav-collapse-button" (click)="toggleSidebar()">
      <qpoint-icon icon="bars"></qpoint-icon>
    </span>
    <span class="title" *ngIf="isTitleAString(title)">{{ titleAsString | translate }}</span>
    <ng-container *ngIf="isTitleAStringArray(title)">
      <ng-container *ngFor="let item of title">
        <span class="toolbar-breadcrump">{{ item }}</span>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isTitleAObjectArray(title)">
      <ng-container *ngFor="let item of title">
        <span class="toolbar-breadcrump" (click)="item.route && navigateTo(item)"
          [ngClass]="{ 'link' : item.route && (item.disabled == null || item.disabled == undefined || !item.disabled) }">
          {{ item.localizeText === undefined || item.localizeText === null || item.localizeText === true ? (item.name |
          translate: item.translationParams) : item.name }}
        </span>
      </ng-container>
    </ng-container>
    <ng-content select="[qpointToolbarLeft]"></ng-content>
  </div>
  <div class="toolbar">
    <ng-content></ng-content>
    <qpoint-export-current-grid *ngIf="!gridConnectService.manuallyPlaceExcelExportButton()"></qpoint-export-current-grid>
    <qpoint-toolbar-divider *ngIf="showContextbarButton"></qpoint-toolbar-divider>
    <qpoint-toolbar-btn *ngIf="showContextbarButton" iconClass="wrench" [active]="!isContextbarCollapsed"
      (btnClick)="toogleContextbar()">
      <div *ngIf="contextbarFilterActive" class="filter-indicator bg-danger"></div>
    </qpoint-toolbar-btn>
    <qpoint-toolbar-divider *ngIf="showAbortButton && showToolbarDividerBeforeAbortButton"></qpoint-toolbar-divider>
    <qpoint-toolbar-btn *ngIf="showAbortButton" iconClass="times" (btnClick)="abort()"
      ngbTooltip="{{ abortButtonTooltip | translate }}" placement="left">
    </qpoint-toolbar-btn>
  </div>
</div>
